import type { SerializedStyles } from "@emotion/serialize";

import { Spacer } from "@aviary";
import { useFlippers } from "@shared/hooks";
import type { PatientAdditionalAttributesType } from "@shared/types/PatientAdditionalAttributesType";
import type { PractitionerAdditionalAttributesType } from "@shared/types/PractitionerAdditionalAttributesType";

import { AppleSSOButton } from "./AppleSSOButton";
import { GoogleSSOButton } from "./GoogleSSOButton";
import { MagicLinkButton } from "./MagicLinkButton";
import type { MagicLinkButtonProps } from "./MagicLinkButton/MagicLinkButton";

interface Props {
  commonSSOProps?: SSOButtonProps;
  magicLinkProps?: MagicLinkButtonProps;
  showMagicLinkButton?: boolean;
}

interface SSOButtonProps {
  treatmentPlanSlug?: string;
  labRecommendationId?: string;
  storeSlug?: string;
  pracTypeId?: string;
  signUpPage?: string;
  pageVersion?: string;
  disabled?: boolean;
  additionalAttributes?: PractitionerAdditionalAttributesType & PatientAdditionalAttributesType;
  uuid?: string;
  buttonStyles?: SerializedStyles;
  orStyles?: SerializedStyles;
}

const LoginOptions = ({ commonSSOProps, magicLinkProps, showMagicLinkButton = false }: Props) => {
  const [isAppleSSO, isInstantLinkEnabled] = useFlippers("apple_sso", "titan_instant_link");

  return (
    <>
      <GoogleSSOButton
        {...commonSSOProps}
        isOrTextRendered={!isAppleSSO && (!showMagicLinkButton || !isInstantLinkEnabled)}
      />
      {isAppleSSO && (
        <>
          <Spacer height="one" />
          <AppleSSOButton
            {...commonSSOProps}
            isOrTextRendered={!showMagicLinkButton || !isInstantLinkEnabled}
          />
        </>
      )}
      {showMagicLinkButton && isInstantLinkEnabled && (
        <>
          <Spacer height="one" />
          <MagicLinkButton {...magicLinkProps} isOrTextRendered />
        </>
      )}
    </>
  );
};

export { LoginOptions };
